let tokenName = 'token'
const JwtService = {
  getToken: (name) => {
    return localStorage.getItem(name || tokenName)
  },

  setToken: (token) => {
    return localStorage.setItem(tokenName, token)
  },

  destroyToken: (name) => {
    return localStorage.removeItem(name || tokenName)
  },
}

export default JwtService
